import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface CloneIssueDestinationStep {
  projectTestlistStepId: number;
  label: string;
  position?: number | null;
  type?: string | null;
  issuesCount: number;
}

export interface CloneIssueModalContext {
  testTitle: string;
  steps: CloneIssueDestinationStep[];
  isLoading: boolean;
  loadError: boolean;
  isSaving: boolean;
  onClose: () => void;
  onConfirm: (destinationProjectTestlistStepIds: number[]) => void;
}

export interface CloneIssueModalState {
  isOpen: boolean;
  context: CloneIssueModalContext | null;
}

@Injectable({
  providedIn: 'root'
})
export class CloneIssueModalService {
  private readonly stateSubject = new BehaviorSubject<CloneIssueModalState>({
    isOpen: false,
    context: null
  });

  readonly state$ = this.stateSubject.asObservable();

  open(context: CloneIssueModalContext): void {
    this.stateSubject.next({ isOpen: true, context });
  }

  update(partial: Partial<CloneIssueModalContext>): void {
    const current = this.stateSubject.getValue();
    if (!current.isOpen || !current.context) {
      return;
    }
    this.stateSubject.next({
      ...current,
      context: { ...current.context, ...partial }
    });
  }

  close(): void {
    this.stateSubject.next({ isOpen: false, context: null });
  }
}
